export default __webpack_public_path__ + "static/media/sqldep.743bc9cd.svg";